module.exports = __webpack_public_path__ + "media/images/lp_flow-cv-678bbe33088984561959a3f9c9dec5f4.webp";